import {createContext} from 'react';
//types
import {POPUP_FORM} from './helpers';

export type FormDataContextType = {
  closeModalClickHandler: () => void;
  changePopupFormHandler: (newForm: POPUP_FORM, emailValue?: string) => void;
};

export const FormDataContext = createContext({} as FormDataContextType);
